import store, { AppDispatch, RootState, StoreActions, reducer as rootReducer } from "client/state/store";

export type { AppDispatch, RootState };
export { StoreActions, rootReducer };
export default store;